import { getReporterFor } from '@thesavingsgroup/reporting/getReporterFor';

export const reporter = getReporterFor({
  app_name: 'rate-calculator',
  app_version: import.meta.env.VITE_APPLICATION_VERSION,
  build_type: import.meta.env.MODE,
});
